var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M-10738.064-5334.983l-2.7-2.7-2.7,2.7a.769.769,0,0,1-1.078,0,.764.764,0,0,1,0-1.081l2.7-2.7-2.7-2.7a.758.758,0,0,1,0-1.076.759.759,0,0,1,1.078,0l2.7,2.7,2.7-2.7a.759.759,0,0,1,1.078,0,.762.762,0,0,1,0,1.076l-2.7,2.7,2.7,2.7a.767.767,0,0,1,0,1.081.765.765,0,0,1-.539.22A.765.765,0,0,1-10738.064-5334.983Z",
    transform: "translate(10744.764 5342.763)",
    fill: "#ababab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCloseIcon);
export default __webpack_public_path__ + "static/media/greyCloseIcon.d80b4bdebd18faf386636ea3ced9ddb1.svg";
export { ForwardRef as ReactComponent };